import * as mediasoup from 'mediasoup-client';
import { getUserMedia } from '../utils/webRTCHelper';
import { mediaServerUrl } from '../utils/constants';

export const InitialiseConnection = () => {
    if(mediaServerUrl){
        const newSocket =  new WebSocket(`${mediaServerUrl}meet`);
        return {newSocket};
    }else {
        return {errorMessage: "Socket Connection Failed: WebSocket not found."}
    }
    
}

export const sendRequest = (socket: WebSocket, type: string, data?: any) => {
    console.log("socket: WebSocket, type: string, data",socket, type, data)
    if(data) {
        socket.send(JSON.stringify({type, data}));
    } else {
        socket.send(JSON.stringify({type}));
    }
}

export const onProducerTransportCreated = async(params: any, device: mediasoup.types.Device, routerRtpCapabilities?: any) => {
    // if(!device.loaded){
    //     await device.load({routerRtpCapabilities});
    // }
    const transportData: mediasoup.types.TransportOptions = {
        id: params.id,
        dtlsParameters: params.dtlsParameters,
        iceCandidates: params.iceCandidates,
        iceParameters: params.iceParameters,
        sctpParameters: params.sctpParameters,
    }

    return device.createSendTransport(transportData);
}

export const InitialiseScreenTransportListener = async(
    screenTransport: mediasoup.types.Transport, 
    socket: WebSocket,
    meetId: string,
    user: {userKey?: string, userName: string, userId: string}
) => {
    screenTransport.on("connect", async({dtlsParameters}, callback, err) => {
        sendRequest(socket, "connectScreenTransport", {dtlsParameters, meetId, userKey: user.userKey});
        socket.addEventListener( "message" , (event: MessageEvent) => {
            const response = JSON.parse(event.data);
            if(response.type === "screenConnected"){
              callback();
            }
        });
    });

    screenTransport.on("produce", async({kind, rtpParameters}, callback, err) => {
        sendRequest(socket, "screenProduce", {transportId: screenTransport.id,  kind, rtpParameters, meetId, user});

        socket.addEventListener("message", (event: MessageEvent) => {
            const data = JSON.parse(event.data);
            if(data.type === "screenVideoProduced"){
                callback(data.response.producerId);
            }
        })
    });

}

export const InitialiseProducerTransportListener = async(
    producerTransport: mediasoup.types.Transport, 
    socket: WebSocket,
    device: mediasoup.types.Device, 
    meetId: string,
    user: {userKey?: string, userName: string, userId: string, avatarKey: string}
) => {
    
    producerTransport.on("connect", async({dtlsParameters}, callback, err) => {
        sendRequest(socket, "connectProducerTransport", {dtlsParameters, meetId, userKey: user.userKey});
        socket.addEventListener( "message" , (event: MessageEvent) => {
            const response = JSON.parse(event.data);
            if(response.type === "producerConnected"){
              callback();
            }
        });
    });

    producerTransport.on("produce", async({kind, rtpParameters}, callback, err) => {
        sendRequest(socket, "produce", {transportId: producerTransport.id,  kind, rtpParameters, meetId, user});

        socket.addEventListener("message", (event: MessageEvent) => {
            const data = JSON.parse(event.data);
            if(data.type === "audioProduced" || data.type === "videoProduced"){
                callback(data.response.producerId);
            }
        })
    });

    if(device.canProduce("video") && device.canProduce("audio")){
        return await getUserMedia({video:true, audio: true}).then( async(stream) => {
            const videotrack = stream.getVideoTracks()[0];
            const audiotrack = stream.getAudioTracks()[0];
            try{
                await producerTransport.produce({track: videotrack});

                const audioProducer = await producerTransport.produce({track: audiotrack});
                // Set up a listener to handle device changes and update the audio track
                handleDeviceChange(audioProducer);

                return stream;
            }catch(error){
                console.log("Can't Produce : ", error);
            }
        });
    }

}

const getUpdatedAudioStream = async () => {
    try {
        const stream = await getUserMedia({ audio: true });
        return stream;
    } catch (error) {
        console.error("# Error accessing audio stream after device change:", error);
        return null;
    }
};

const replaceAudioTrack = async (
    audioProducer: mediasoup.types.Producer<mediasoup.types.AppData>,
    newTrack: MediaStreamTrack
) => {
    if (audioProducer) {
        await audioProducer.replaceTrack({ track: newTrack });
    } else {
        console.error("# No audio producer found to replace the track.");
    }
};

export const handleDeviceChange = async (
    audioProducer: mediasoup.types.Producer<mediasoup.types.AppData>
) => {
    navigator.mediaDevices.ondevicechange = async () => {
        console.log("# Device change detected, updating audio stream...");
        const updatedStream = await getUpdatedAudioStream();
        if (updatedStream) {
            const audiotrack = updatedStream.getAudioTracks()[0];
            if (audiotrack) {
                try {
                    await replaceAudioTrack(audioProducer, audiotrack);
                    console.log("# Audio track updated successfully");
                } catch (error) {
                    console.error("# Error updating audio track:", error);
                }
            }
        }
    };
};


export const InitialiseUpdateProducerTransportListener = async(
    producerTransport: mediasoup.types.Transport, 
    socket: WebSocket,
    device: mediasoup.types.Device, 
    meetId: string,
    user: {userKey?: string, userName: string, userId: string, avatarKey: string}) => {
    
    producerTransport.on("connect", async({dtlsParameters}, callback, err) => {
        sendRequest(socket, "connectUpdateProducerTransport", {dtlsParameters, meetId, userKey: user.userKey});
        socket.addEventListener( "message" , (event: MessageEvent) => {
            const response = JSON.parse(event.data);
            if(response.type === "updateProducerConnected"){
              callback();
            }
        });
    });

    producerTransport.on("produce", async({kind, rtpParameters}, callback, err) => {
        sendRequest(socket, "updateProduce", {transportId: producerTransport.id,  kind, rtpParameters, meetId, user});

        socket.addEventListener("message", (event: MessageEvent) => {
            const data = JSON.parse(event.data);
            if(data.type === "audioProduced" || data.type === "videoProduced"){
                callback(data.response.producerId);
            }
        })
    });

    if(device.canProduce("video")){
        return await getUserMedia({video:true, audio: true}).then( async(stream) => {
            const videotrack = stream.getVideoTracks()[0];
            try{
                await producerTransport.produce({track: videotrack});
                return stream;
            }catch(error){
                console.log("Can't Produce : ", error);
            }
        });
    }
}

export const onConsumerTransportCreated = async(params: any, device: mediasoup.types.Device) => {
    const transportData: mediasoup.types.TransportOptions = {
        id: params.id,
        dtlsParameters: params.dtlsParameters,
        iceCandidates: params.iceCandidates,
        iceParameters: params.iceParameters,
        sctpParameters: params.sctpParameters
    }

    return device.createRecvTransport(transportData); 

}

export const InitialiseConsumerTransportListener = (consumerTransport: mediasoup.types.Transport, device: mediasoup.Device ,socket: WebSocket, meetId: string, userKey: string) => {

    consumerTransport.on("connectionstatechange", (state) => {
        console.log("connectionstatechange : ", state)
        switch(state){
            case "connected" : 
                sendRequest(socket, "resumeConsumer", {meetId, userKey});
        }
    });
}


export const onConsumed = async(data: {
    consumerId: string,
    kind: mediasoup.types.MediaKind,
    producerId: string,
    producerPaused: boolean,
    rtpParameters: mediasoup.types.RtpParameters,
    type: string
}, consumerTransport: mediasoup.types.Transport) => {
    consumerTransport.on("connectionstatechange", (state) => {
        console.log(state)
    });
    consumerTransport.on("connect", async() => {
        const consumer = await consumerTransport.consume({
            id: data.consumerId,
            producerId: data.producerId,
            kind: data.kind,
            rtpParameters: data.rtpParameters
        });
        console.log("Consumer Track : ", consumer.track);
        const stream = new MediaStream();
        stream.addTrack(consumer.track);
        console.log("New Stream : ", stream);
    });
   
}